import React, { useState, useEffect } from 'react';
import { HiArrowNarrowUp } from 'react-icons/hi';
import { animateScroll as scroll } from 'react-scroll';
import { motion, AnimatePresence } from 'framer-motion';

const BackToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 500) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () => {
        scroll.scrollToTop();
    };

    return (
        <AnimatePresence>
            {isVisible && (
                <motion.div
                    initial={{ opacity: 0, scale: 0.5, y: 50 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.5, y: 50 }}
                    onClick={scrollToTop}
                    className="fixed bottom-10 right-10 z-[80] p-4 glass rounded-full text-accent-primary text-2xl cursor-pointer hover:border-accent-primary hover:text-white transition-all duration-300 glow"
                >
                    <HiArrowNarrowUp />
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default BackToTop;
